// extracted by mini-css-extract-plugin
export default {"container":"QrScanner_container__AZ6yi","data":"QrScanner_data__JS+pq","video":"QrScanner_video__7jQmy","div":"QrScanner_div__DfPTw"};